/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DisconnectedSignedConfigResponse } from './disconnectedSignedConfigResponse';


export interface DisconnectedConfigResponseSpec { 
    component_config?: Array<DisconnectedSignedConfigResponse>;
}

